import React from "react";
import ReactEcharts from "echarts-for-react";

export const StcTimeChart = ({ readings }) => {
  const option = {
    grid: {
      left: 50,
      right: 50,
      top: 40,
      bottom: 80,
    },
    xAxis: {
      type: "time",
      axisLabel: { color: "#ccc", fontSize: 10 },
    },
    yAxis: [
      {
        name: "Pressure",
        type: "value",
        alignTicks: true,
        nameTextStyle: { color: "#ccc", fontSize: 11 },
        axisLabel: { color: "#ccc", fontSize: 10 },
      },
      {
        name: "Flow",
        type: "value",
        alignTicks: true,
        nameTextStyle: { color: "#ccc", fontSize: 11 },
        axisLabel: { color: "#ccc", fontSize: 10 },
      },
    ],
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "cross" },
      confine: true,
    },
    legend: {
      data: ["Inlet", "Filtered", "Flow"],
      textStyle: { color: "#ccc", fontSize: 11 },
      top: 0,
    },
    dataZoom: [
      {
        type: "inside",
        xAxisIndex: 0,
        filterMode: "filter",
      },
      {
        type: "slider",
        xAxisIndex: 0,
        height: 20,
        bottom: 8,
        borderColor: "#555",
        fillerColor: "rgba(74,144,217,0.3)",
        handleStyle: { color: "#4a90d9" },
        textStyle: { color: "#ccc", fontSize: 10 },
      },
    ],
    series: [
      {
        name: "Inlet",
        data: readings?.map((r) => [r.timestamp, r.pressure_1]),
        type: "line",
        yAxisIndex: 0,
        symbol: "none",
        lineStyle: { width: 1.5 },
      },
      {
        name: "Filtered",
        data: readings?.map((r) => [r.timestamp, r.pressure_2]),
        type: "line",
        yAxisIndex: 0,
        symbol: "none",
        lineStyle: { width: 1.5 },
      },
      {
        name: "Flow",
        data: readings?.map((r) => [r.timestamp, r.flow]),
        type: "line",
        areaStyle: { opacity: 0.3 },
        yAxisIndex: 1,
        symbol: "none",
        lineStyle: { width: 1.5 },
      },
    ],
  };

  return (
    <ReactEcharts
      option={option}
      style={{ height: 320, width: "100%" }}
      opts={{ renderer: "canvas" }}
    />
  );
};
